export default {
  error: {
    onlineCheck:
      'The current number of logins exceeds the maximum number. Please try again later.',
  },
}
